import { getCookie } from './get_cookie';

export function isVisibaIOSApp(): boolean {
	try {
		const cookie = getCookie('VisibaIOSApp');

		return !!cookie;
	} catch {
		return false;
	}
}
